/**
 * ToastContainer Component
 *
 * Componente que exibe os toasts de feedback
 */
import React from 'react'
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react'
import { useFeedbackStore } from '../stores/feedbackStore'

const iconMap = {
	success: CheckCircle,
	error: XCircle,
	warning: AlertTriangle,
	info: Info,
}

const colorMap = {
	success: {
		bg: 'bg-success/10',
		border: 'border-success/30',
		icon: 'text-success',
		text: 'text-success',
	},
	error: {
		bg: 'bg-danger/10',
		border: 'border-danger/30',
		icon: 'text-danger',
		text: 'text-danger',
	},
	warning: {
		bg: 'bg-warning/10',
		border: 'border-warning/30',
		icon: 'text-warning',
		text: 'text-warning',
	},
	info: {
		bg: 'bg-info/10',
		border: 'border-info/30',
		icon: 'text-info',
		text: 'text-info',
	},
}

function Toast({ toast, onRemove }) {
	const Icon = iconMap[toast.type] || Info
	const colors = colorMap[toast.type] || colorMap.info

	return (
		<div
			className={`
				flex items-start gap-3 p-4 rounded-lg border shadow-lg
				${colors.bg} ${colors.border}
				animate-slide-in
			`}
		>
			<Icon className={`w-5 h-5 flex-shrink-0 ${colors.icon}`} />
			<div className="flex-1 min-w-0">
				{toast.title && (
					<p className={`font-medium ${colors.text}`}>{toast.title}</p>
				)}
				<p className={`text-sm ${toast.title ? 'text-text-body' : colors.text}`}>
					{toast.message}
				</p>
			</div>
			<button
				onClick={() => onRemove(toast.id)}
				className="p-1 hover:bg-base-400/50 rounded transition-colors"
			>
				<X className="w-4 h-4 text-text-body" />
			</button>
		</div>
	)
}

export default function ToastContainer() {
	const { toasts, removeToast } = useFeedbackStore()

	if (toasts.length === 0) return null

	return (
		<div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-sm w-full">
			{toasts.map((toast) => (
				<Toast key={toast.id} toast={toast} onRemove={removeToast} />
			))}
		</div>
	)
}

export { Toast }
